import React, { useState, useContext } from "react";
import { v4 as uuidv4 } from "uuid";
import { GlobalContext } from "../context/GlobalState";

const AddTransaction = () => {
  const [income, setIncome] = useState({
    incomeText: "",
    incomeAmount: 0,
  });

  const { incomeText, incomeAmount } = income;

  const { addIncome } = useContext(GlobalContext);

  const handleOnChangeIncome = (e) => {
    setIncome({
      ...income,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnSubmitIncome = (e) => {
    e.preventDefault();

    if (incomeText !== "" && incomeAmount !== 0) {
      const newIncomeTransaction = {
        id: uuidv4(),
        incomeText,
        incomeAmount: incomeAmount * 1,
      };

      addIncome(newIncomeTransaction);
    } else {
      alert("Fields cannot be empty");
    }

    setIncome({
      ...income,
      incomeText: "",
      incomeAmount: 0,
    });
  };

  const [expense, setExpense] = useState({
    expenseText: "",
    expenseAmount: 0,
  });

  const { expenseText, expenseAmount } = expense;

  const { addExpense } = useContext(GlobalContext);

  const handleOnChangeExpense = (e) => {
    setExpense({
      ...expense,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnSubmitExpsense = (e) => {
    e.preventDefault();

    if (expenseText !== "" && expenseAmount !== 0) {
      const newExpenseTransaction = {
        id: uuidv4(),
        expenseText,
        expenseAmount: expenseAmount * 1,
      };

      addExpense(newExpenseTransaction);
    } else {
      alert("Fields cannot be empty");
    }

    setExpense({
      ...expense,
      expenseText: "",
      expenseAmount: 0,
    });
  };

  return (
    <div className="form-wrapper">
      <form onSubmit={handleOnSubmitIncome}>
        <div className="input-group income">
          <input
            type="text"
            name="incomeText"
            value={incomeText}
            placeholder="Add Income..."
            autoComplete="off"
            onChange={handleOnChangeIncome}
          />
          <input
            type="number"
            name="incomeAmount"
            value={incomeAmount}
            placeholder="Enter Amount.."
            autoComplete="off"
            onChange={handleOnChangeIncome}
          />
          <input type="submit" value="submit" autoComplete="off" />
        </div>
      </form>

      <form onSubmit={handleOnSubmitExpsense}>
        <div className="input-group expense">
          <input
            type="text"
            name="expenseText"
            value={expenseText}
            placeholder="Add Expense.."
            autoComplete="off"
            onChange={handleOnChangeExpense}
          />
          <input
            type="number"
            name="expenseAmount"
            value={expenseAmount}
            placeholder="Enter Amount.."
            autoComplete="off"
            onChange={handleOnChangeExpense}
          />
          <input type="submit" value="submit" autoComplete="off" />
        </div>
      </form>
    </div>
  );
};

export default AddTransaction;
